export default __webpack_public_path__ + "5e70129667ae5933de7a2d4d3530c84c.jpg";